import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import fr from './fr.json';

// Restore the persisted language choice (survives full page reloads)
const getStoredLanguage = () => {
  try {
    const stored = window.localStorage.getItem('app_language');
    return stored === 'en' || stored === 'fr' ? stored : null;
  } catch (e) {
    return null;
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr }
    },
    lng: getStoredLanguage() || 'fr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Keep the <html lang> attribute in sync with the app language.
// Combined with translate="no", this prevents browser auto-translation
// from mutating React-managed DOM nodes (insertBefore crashes).
const syncHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng || 'fr');
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', (lng) => {
  syncHtmlLang(lng);
  try {
    window.localStorage.setItem('app_language', lng);
  } catch (e) {
    // Storage unavailable (private mode) - non-critical
  }
});

export default i18n;
